import React, { useEffect, useState}  from 'react'
import CardCate from '../../Common/Cards/CardCate'
import { useParams } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

function Awards() {

  const { id } = useParams();

  console.log(id);

  
  const [eventData, setEventData] = useState([]);

  // sketon state
  const [loading, setLoading]=useState(true);


  useEffect(() => {
    // Fetch JSON data from your API endpoint
    fetch(`https://hstonline.tech/hstsms/api/v1/programs/${id}`)
      .then(response => response.json())
      .then(data => {
        console.log('Fetched data:', data);   
        setEventData(data.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [id]);

  console.log('eventData:', eventData);


  // fetch categories


  const [categoryData, setCategorytData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    // Fetch JSON data from your API endpoint
    fetch(`https://hstonline.tech/hstsms/api/v1/categories?program_id=${id}`)
      .then(response => response.json())
      .then(data => {
        console.log('Fetched data:', data);

        setCategorytData(data.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching data: here', error);
      });
  }, [id]);

  console.log('eventData:', categoryData);

  // Filter categories based on search query
  const filteredCategories = categoryData.filter(category =>
    category.name.toLowerCase().includes(searchQuery.toLowerCase())
  );



  return (
    <div className='flex flex-col m-auto page'>
      <section className="awardDes flex w-full mt-5 mb-3 pb-5 items-start" style={{borderBottom: '3px solid #0f305f'}}>
        {/* <div className="eventImage w-1/2" style={{ height: '300px', objectFit: 'cover', objectPosition: 'top' }}>
          <img className='img-fit' src={eventData.image_url} alt="" />
        </div> */}

        {/*image skeleton below  */}
    {loading ?(
      <Skeleton count={1} height={400} duration={1}/>
    ):(

      <div className="eventImage w-1/2" style={{ height: '300px', backgroundImage: `url(${eventData.image_url})`, backgroundSize: 'cover', backgroundPosition: 'top' }}></div>

   )}

        <div className='desContent w-1/2 text-left px-5'>
          <h1 className='font-bold text-3xl'>{eventData.name}</h1>

          <div className="flex flex-col items-start mb-3 mt-4 text-left w-full">
            <p>Date</p>
            <small className='text-gray-400'>9th October,2025</small>
          </div>

          <div className="flex flex-col items-start mb-3 text-left w-full">
            <p>Description</p>
            <small className='text-gray-400'>WNMFPA AWARDS 2025

</small>
          </div>

          <div className="flex flex-col items-start mb-3 text-left w-full">
            <p>Organizer</p>
            <small className='text-gray-400'>WNMFPA</small>
          </div>
        </div>
      </section>

      {/* Categories Header and Search */}
      <div className="my-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <h1 className='text-2xl font-bold text-gray-800'>Categories</h1>

        {/* Search Bar */}
        <input
          type="text"
          placeholder="Search categories..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full md:w-96 px-5 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-gray-500 text-base"
        />
      </div>

      {loading ? (
        <Skeleton count={3} height={50} direction='rtl'/>
      ) : (
        <>
          {/* Results count */}
          {searchQuery && (
            <div className="mb-3 text-sm text-gray-500">
              {filteredCategories.length} {filteredCategories.length === 1 ? 'result' : 'results'}
            </div>
          )}

          <section className="flex flex-wrap justify-center w-full my-3 pt-2" style={{borderTop: '3px solid #0f305f'}}>
            {filteredCategories.length > 0 ? (
              filteredCategories.map(event => (
                <CardCate key={event.id} data={event} />
              ))
            ) : (
              <div className="w-full text-center py-16">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto mb-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h3 className="text-xl font-semibold text-gray-600 mb-2">No categories found</h3>
                <p className="text-gray-500">Try adjusting your search query</p>
              </div>
            )}
          </section>
        </>
      )}
    </div>
  )
}

export default Awards